/**
 * Tab shell. Mobile: bottom tabs. Desktop web (≥1024px): the bottom bar hides
 * and the persistent left sidebar comes from the ROOT DesktopFrame
 * (components/shell/DesktopShell) — which wraps every app route, not just tabs —
 * so this layout only renders the routed tab content on desktop.
 */
import { Tabs } from 'expo-router';
import React from 'react';
import { Platform, useWindowDimensions } from 'react-native';

import { Icon } from '@/features/account-admin/icons';
import { useT } from '@/i18n';
import { useTheme } from '@/theme';

const WIDE = 1024;

export default function TabsLayout() {
  const { t } = useT();
  const { colors } = useTheme();
  const { width } = useWindowDimensions();
  const wide = Platform.OS === 'web' && width >= WIDE;

  return (
    <Tabs
      backBehavior="history"
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: colors.primary500,
        tabBarInactiveTintColor: colors.textTertiary,
        tabBarStyle: wide ? { display: 'none' } : { backgroundColor: colors.canvas0, borderTopColor: colors.borderSoft },
        tabBarLabelStyle: { fontSize: 12, fontFamily: 'Inter_500Medium' },
      }}
    >
      <Tabs.Screen name="home" options={{ title: t('tab_home'), tabBarIcon: ({ color }) => <Icon name="home" size={22} color={String(color)} /> }} />
      <Tabs.Screen name="community" options={{ title: t('tab_community'), tabBarIcon: ({ color }) => <Icon name="megaphone" size={22} color={String(color)} /> }} />
      <Tabs.Screen name="gate" options={{ title: t('tab_gate'), tabBarIcon: ({ color }) => <Icon name="shield" size={22} color={String(color)} /> }} />
      <Tabs.Screen name="pay" options={{ title: t('tab_pay'), tabBarIcon: ({ color }) => <Icon name="credit-card" size={22} color={String(color)} /> }} />
      {/* Profile removed from the tab bar (redundant with the top-right avatar);
          kept as a route so /profile still resolves inside the tabs layout. */}
      <Tabs.Screen name="profile" options={{ href: null }} />
    </Tabs>
  );
}
